import React, {Children, cloneElement, Fragment} from 'react';
import {useFormContext} from 'react-hook-form';

export default function RepeatedFieldsContainer({message, children}) {
    const {
        getValues,
        register,
        trigger,
        formState: {touchedFields},
    } = useFormContext();
    const firstChildProps = Children.toArray(children)[0].props;
    const secondChildProps = Children.toArray(children)[1].props;
    const isSameValue = (value) => getValues(firstChildProps.name) === value || message;

    return (
        <>
            {children.map((child, index) => {
                const isFirstChild = index === 0;
                const isSecondChild = index === 1;
                if (isFirstChild) {
                    const {onChange, onBlur} = register(child.props.name);
                    const modifiedOnChange = (event) => {
                        const repeatedFieldIsTouched = touchedFields?.[secondChildProps.name];
                        if (repeatedFieldIsTouched) {
                            trigger(secondChildProps.name);
                        }
                        onChange(event);
                    };
                    const modifiedProps = {...child.props, key: index, onChange: modifiedOnChange, onBlur};
                    return cloneElement(child, modifiedProps);
                } else if (isSecondChild) {
                    const modifiedProps = {
                        ...child.props,
                        key: index,
                        validation: {
                            validate: {
                                ...child?.props?.validation?.validate,
                                same: isSameValue,
                            },
                        },
                    };
                    return cloneElement(child, modifiedProps);
                } else {
                    return cloneElement(child, child.props);
                }
            })}
        </>
    );
}
